import React from "react";
import ReactDOM from "react-dom/client";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";

import "./index.css";
import "leaflet/dist/leaflet.css";

import App from "./App";
import { msalConfigHavoxCases } from "./auth/msalConfigHavoxCases";

const msalInstance = new PublicClientApplication(msalConfigHavoxCases);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>
);
